import ContactSection from "../components/ContactSection";

export default function ContactPage() {
  return (
    <main className="pt-[72px]" data-testid="contact-page">
      <ContactSection />
    </main>
  );
}
